import { render, staticRenderFns } from "./CityRanking.vue?vue&type=template&id=8dae635a&scoped=true&"
import script from "./CityRanking.vue?vue&type=script&lang=js&"
export * from "./CityRanking.vue?vue&type=script&lang=js&"
import style0 from "./CityRanking.vue?vue&type=style&index=0&id=8dae635a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dae635a",
  null
  
)

export default component.exports